/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ConfirmDeletionModalQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  requirementId: Types.Scalars['ID']['input'];
}>;


export type ConfirmDeletionModalQuery = { requirement: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'RequirementResult', requirement?: { __typename: 'Requirement', id: string, outgoingRequests: Array<{ __typename: 'Request', id: string, title: string }> } | null } };


export const ConfirmDeletionModalDocument = gql`
    query ConfirmDeletionModal($projectId: ID!, $requirementId: ID!) {
  requirement(projectId: $projectId, docId: $requirementId) {
    ... on RequirementResult {
      requirement {
        id
        outgoingRequests {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useConfirmDeletionModalQuery__
 *
 * To run a query within a React component, call `useConfirmDeletionModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmDeletionModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmDeletionModalQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      requirementId: // value for 'requirementId'
 *   },
 * });
 */
export function useConfirmDeletionModalQuery(baseOptions: Apollo.QueryHookOptions<ConfirmDeletionModalQuery, ConfirmDeletionModalQueryVariables> & ({ variables: ConfirmDeletionModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfirmDeletionModalQuery, ConfirmDeletionModalQueryVariables>(ConfirmDeletionModalDocument, options);
      }
export function useConfirmDeletionModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfirmDeletionModalQuery, ConfirmDeletionModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfirmDeletionModalQuery, ConfirmDeletionModalQueryVariables>(ConfirmDeletionModalDocument, options);
        }
export function useConfirmDeletionModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfirmDeletionModalQuery, ConfirmDeletionModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfirmDeletionModalQuery, ConfirmDeletionModalQueryVariables>(ConfirmDeletionModalDocument, options);
        }
export type ConfirmDeletionModalQueryHookResult = ReturnType<typeof useConfirmDeletionModalQuery>;
export type ConfirmDeletionModalLazyQueryHookResult = ReturnType<typeof useConfirmDeletionModalLazyQuery>;
export type ConfirmDeletionModalSuspenseQueryHookResult = ReturnType<typeof useConfirmDeletionModalSuspenseQuery>;
export type ConfirmDeletionModalQueryResult = Apollo.QueryResult<ConfirmDeletionModalQuery, ConfirmDeletionModalQueryVariables>;